module.exports = __webpack_public_path__ + "assets/img/地图.0507abe5.png";